import { CategoryBarChart } from '@factorialco/f0-react'

type ChartData = {
  color?:
    | 'categorical-1'
    | 'categorical-2'
    | 'categorical-3'
    | 'categorical-4'
    | 'categorical-5'
    | 'categorical-6'
    | 'categorical-7'
    | 'categorical-8'
    | 'feedback-positive'
    | 'feedback-negative'
    | 'feedback-neutral'
  label: string
  value: number
  formattedValue?: string
}

interface CategoryBarChartWrapperProps {
  groupedChartData: ChartData[]
}

export const CategoryBarChartWrapper = ({ groupedChartData }: CategoryBarChartWrapperProps) => {
  const categoryChartData = groupedChartData.map((x) => ({
    name: x.label + ' ' + x.formattedValue,
    value: x.value,
    color: x.color,
  }))

  return <CategoryBarChart data={categoryChartData} legend />
}
